/* eslint-disable import/prefer-default-export */
import React from 'react';

export const getLoaderWithFallbackUrl = (fallbackUrl) => {
  const Loader = function ({ style, className }) {
    return <img src={fallbackUrl} style={style} className={className} alt='' />;
  };
  return Loader;
};
